import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function SampleChip({ shift, color, label, timeLabel, isActive, isLeave, onPointerDown }) {
  return (
    <Box
      onPointerDown={onPointerDown}
      sx={{
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "8px",
        px: 1,
        py: 0.5,
        minWidth: 52,
        minHeight: 36,
        cursor: "grab",
        touchAction: "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        backgroundColor: isLeave ? "#fff" : color,
        border: isLeave
          ? `2px solid ${color}`
          : isActive
          ? "2px solid rgba(255,255,255,0.8)"
          : "2px solid transparent",
        boxShadow: isActive
          ? `0 0 0 2px ${color}, 0 4px 12px rgba(0,0,0,0.2)`
          : "0 1px 4px rgba(0,0,0,0.12)",
        opacity: isActive ? 0.7 : 1,
        transform: isActive ? "scale(0.95)" : "scale(1)",
        transition: "box-shadow 0.15s ease, transform 0.15s ease, opacity 0.15s ease",
      }}
    >
      <Typography
        noWrap
        sx={{
          fontSize: "0.62rem",
          fontWeight: 700,
          lineHeight: 1.2,
          color: isLeave ? color : "#fff",
          textAlign: "center",
          maxWidth: 70,
        }}
      >
        {label}
      </Typography>
      {timeLabel && (
        <Typography
          noWrap
          sx={{
            fontSize: "0.55rem",
            fontWeight: 500,
            lineHeight: 1.1,
            color: isLeave ? "text.secondary" : "rgba(255,255,255,0.85)",
            textAlign: "center",
          }}
        >
          {timeLabel}
        </Typography>
      )}
    </Box>
  );
}
